import React, { useCallback } from 'react';
import { Box, Button, Heading } from '@edreamsodigeo/prisma-design-system';
import { useTranslation, useTracking } from '@edreamsodigeo/frontend-core';

const ValuePropositionFooter = () => {
  const { t } = useTranslation();
  const { trackEvent } = useTracking();
  const helpCenterLink = t('variables.help.url');

  const onClickHelpCenter = useCallback(() => {
    trackEvent({
      category: 'mytripslogin',
      action: 'help_center',
      label: 'click:help-center-link_pag:mytriplogin',
    });
    window.open(helpCenterLink);
  }, [trackEvent, helpCenterLink]);
  return (
    <>
      <Heading type="6" color="neutral.90">
        {t('supportarea.mytripslogin.banner.footer.text.desktop.1')}
      </Heading>
      <Box mt="small">
        <Button type="primary" onClick={onClickHelpCenter}>
          <Heading type="6">
            {t('supportarea.mytripslogin.banner.footer.text.desktop.2')}
          </Heading>
        </Button>
      </Box>
    </>
  );
};

export default ValuePropositionFooter;
